import React from 'react';
import { SummaryForm, OfferingsForm, FormWrapper } from '../components/Forms';
import useSummaryAndOfferings from '../hooks/useSummaryAndOfferings';
import Tabs from '../components/ui/Tabs';

const ProfilePage = () => {
  const {
    profileSummary,
    summaryLoading,
    summaryError,
    profileOfferings,
    offeringsLoading,
    offeringsError,
    handleSaveSummary,
    handleSaveOffering,
    handleDeleteOffering,
    updateSummaryMutation,
    updateOfferingMutation,
    handleAddOffering,
    isMobile,
  } = useSummaryAndOfferings();
  return (
    <div className='h-[calc(100vh-8rem)] overflow-hidden flex flex-col'>
      <div className='max-w-[1600px] mx-auto h-full flex-1 flex flex-col'>
        <Tabs
          className='lg:hidden flex-1 min-h-0'
          tabs={[
            { id: 'summary', title: 'Summary' },
            { id: 'offerings', title: 'Offerings' },
          ]}
        >
          <FormWrapper
            tabId='summary'
            isLoading={summaryLoading}
            error={summaryError}
            data={profileSummary}
            errorMessage='Failed to load profile summary'
            className='h-full'
          >
            <SummaryForm
              initialData={profileSummary}
              onSave={handleSaveSummary}
              isLoading={updateSummaryMutation.isPending}
            />
          </FormWrapper>

          {/* Offerings Section */}
          <FormWrapper
            isLoading={offeringsLoading}
            error={offeringsError}
            data={profileOfferings}
            errorMessage='Failed to load offerings'
            tabId='offerings'
            className='h-full'
          >
            <OfferingsForm
              initialData={profileOfferings || []}
              onSave={handleSaveOffering}
              isLoading={updateOfferingMutation.isPending}
              onDelete={handleDeleteOffering}
              onAdd={handleAddOffering}
            />
          </FormWrapper>
        </Tabs>
        <div className='hidden lg:grid lg:grid-cols-1 xl:grid-cols-12 gap-6 flex-1 min-h-0'>
          {/* Summary Section */}
          <FormWrapper
            isLoading={summaryLoading}
            error={summaryError}
            data={profileSummary}
            errorMessage='Failed to load profile summary'
            className='desktop-tour-summary-section xl:col-span-6 h-full overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-slate-200 scrollbar-track-transparent hover:scrollbar-thumb-slate-300'
          >
            <SummaryForm
              initialData={profileSummary}
              onSave={handleSaveSummary}
              isLoading={updateSummaryMutation.isPending}
            />
          </FormWrapper>

          {/* Offerings Section */}
          <FormWrapper
            isLoading={offeringsLoading}
            error={offeringsError}
            data={profileOfferings}
            errorMessage='Failed to load offerings'
            className='desktop-tour-offerings-section xl:col-span-6 h-full overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-slate-200 scrollbar-track-transparent hover:scrollbar-thumb-slate-300'
          >
            <OfferingsForm
              initialData={profileOfferings || []}
              onSave={handleSaveOffering}
              isLoading={updateOfferingMutation.isPending}
              onDelete={handleDeleteOffering}
              onAdd={handleAddOffering}
            />
          </FormWrapper>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
